import React, { HTMLAttributes } from 'react';
import { cn, getInitials, stringToHslColor } from '../../helpers';
import { useImage } from '../../hooks';
import { Image } from '..';
import styles from './avatar.module.scss';

interface AvatarProps extends HTMLAttributes<HTMLElement> {
    senderName: string;
    senderLogoUrl: string;
}

export const Avatar = ({ senderName, senderLogoUrl, className, style, ...props }: AvatarProps): JSX.Element => {
    const status = useImage({ src: senderLogoUrl });

    const classes = cn(styles.avatar, 'align-items-center justify-content-center', {
        [className]: className,
    });

    const customStyle = {
        ...style,
        backgroundColor: status === 'loaded' ? 'white' : stringToHslColor(senderName),
    };

    const Avatar =
        status === 'loaded' ? (
            <Image className={styles.image} src={senderLogoUrl} alt={senderName} />
        ) : (
            <span>{getInitials(senderName).toUpperCase()}</span>
        );

    return (
        <div className={classes} style={customStyle} {...props}>
            {Avatar}
        </div>
    );
};
